import { render } from "./KpiTableHeader.vue?vue&type=template&id=c8bffa48&scoped=true"
import script from "./KpiTableHeader.vue?vue&type=script&lang=js"
export * from "./KpiTableHeader.vue?vue&type=script&lang=js"

import "./KpiTableHeader.vue?vue&type=style&index=0&id=c8bffa48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8bffa48"]])

export default __exports__